/**
 * Platform Detection — Tauri vs 브라우저 구분
 *
 * @module db/platform
 */

/** Tauri 런타임인지 확인 */
export function isTauri(): boolean {
  return typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
}
